import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { RestResponse, RestService } from '@tdwb/core';
import { RecentSearchItem, SearchResult } from './site-wide-search.domain';

@Injectable()
export class SiteWideSearchRestService {
  private readonly restService = inject(RestService);

  search(searchTerm: string): Observable<SearchResult> {
    const params = {
      pathVariables: {
        searchTerm
      }
    };
    return this.restService.getResource('search.site-wide-search').get(params);
  }

  getRecentSearches(): Observable<Array<RecentSearchItem>> {
    return this.restService.getResource('recent-searches.list')
      .get<Array<RecentSearchItem>>()
      .pipe(
        map((response: Array<RecentSearchItem>): Array<RecentSearchItem> => {
          if (response !== undefined) {
            return response.sort(this.compare);
          }
        })
      );
  }

  setRecentSearch(searchText: string): Observable<RestResponse<unknown>> {
    return this.restService.getResource('recent-searches.update').post({ searchText });
  }

  setRecentSymbolSearch(symbolSearchItem: RecentSearchItem): Observable<RestResponse<unknown>> {
    const params: RecentSearchItem = {
      searchText: symbolSearchItem.searchText,
      market: symbolSearchItem.market,
      symbolType: symbolSearchItem.symbolType
    };
    return this.restService.getResource('recent-searches.update').post(params);
  }

  deleteRecentSearch(recentSearchList: Array<RecentSearchItem>): Observable<RestResponse<unknown>> {
    return this.restService.getResource('recent-searches.remove-requests').post(recentSearchList);
  }

  private compare(a: RecentSearchItem, b: RecentSearchItem): number {
    if (a.priority < b.priority) {
      return -1;
    }
    if (a.priority > b.priority) {
      return 1;
    }
    return 0;
  }
}
